<section formEnhance [callback]="search" class="FIND_CLINICS">
  <div class="l-flex l-flex-wrap t-panel l-align-y">
    <input-wrap>
      <input
        class="t-input t-input-icon-search"
        type="text"
        [(ngModel)]="clinicId"
        placeholder="{{ 'translate.general.clinicId' | translate }}"
        (keypress)="onKeyPress($event)"
      />
    </input-wrap>

    <input-wrap [loading]="clinicList && clinicList.loading">
      <p-select
        #hasSearchDropdown
        [options]="clinicList"
        optionLabel="label"
        [(ngModel)]="selectedClinic"
        [filterPlaceholder]="'translate.general.search' | translate"
        [placeholder]="'translate.general.clinic' | translate"
        [filter]="true"
        [resetFilterOnHide]="true"
        name="selectedClinic"
        (onChange)="onFieldValueChanged($event)"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
      >
      </p-select>
      <clear-multi
        *ngIf="selectedClinic"
        (click)="selectedClinic = null; search()"
      ></clear-multi>
    </input-wrap>

    <span class="spacer t-space--med"></span>
    <button class="t-button t-button--flat" (click)="search()">
      {{ "translate.general.search" | translate }}
    </button>
    <span class="spacer t-space--small"></span>
    <button class="t-button-outline c-c1" (click)="clearSearch()">
      {{ "translate.general.clearFilter" | translate }}
    </button>
  </div>
</section>
